import YouTubePlayer from './YouTubePlayer.js';

/**
 * SeminarVideo
 * TOP 無料集客セミナーの左ステージを YouTube インライン自動再生にする（顧客要望）。
 *
 * ステージの切替自体は Switcher（.js-switcher）が担当。ここは切替に合わせた再生対象の付け替えのみ：
 * - 右リストの .js-switcher-trigger クリック → 対応ステージを再生（他は撤去して停止）。
 * iframeの差し込みと画面内外での再生/一時停止は YouTubePlayer（共通）。
 */
export default class SeminarVideo extends YouTubePlayer {
  constructor(options = {}) {
    const root = document.querySelector(options.rootSelector || '.js-seminar');
    const items = root ? Array.from(root.querySelectorAll('.p-seminar-stage-item')) : [];
    const active = items.findIndex((item) => item.classList.contains('is-active'));
    super(root, {
      items,
      activeIndex: active < 0 ? 0 : active,
      holderSelector: '.js-seminar-player',
      iframeClass: 'p-seminar-stage-iframe',
    });
    if (!this.root || this.items.length === 0) {
      return;
    }

    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.root.querySelectorAll('.js-switcher-trigger').forEach((trigger) => {
      trigger.addEventListener('click', this.onTriggerClick);
    });
  }

  /**
   * @param {MouseEvent} event
   */
  onTriggerClick(event) {
    const href = event.currentTarget.getAttribute('href') || '';
    if (!href.startsWith('#')) {
      return;
    }
    const index = this.items.findIndex((item) => item.id === href.slice(1));
    if (index < 0) {
      return;
    }
    this.activeIndex = index;
    this.items.forEach((item, i) => {
      if (i !== index) {
        this.unmount(item);
      }
    });
    this.mount(this.activeItem());
  }
}
